var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('Header'),(_vm.user)?_c('router-view'):_c('div',[_vm._v("You must "),_c('a',{attrs:{"href":_vm.externalLoginLink}},[_vm._v("log in")]),_vm._v(" first")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }